import React from "react";
import RealEstateService from "./RealEstateService";
import { Button, Grid } from "@mui/material";
import img1 from "../../../../assets/picsAppartamenti/valutazione.webp";
import img2 from "../../../../assets/picsAppartamenti/covervendita.webp";
import img3 from "../../../../assets/picsAppartamenti/affittasi.webp";
import { Stack, useMediaQuery } from "@mui/system";
import ButtonUX from "../../Button/ButtonUX";
import { ContactMail } from "@mui/icons-material";
import { Link } from "react-router-dom";

const RealEstateServizi = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const properties = [
    {
      image: img1,
      title: "Valutazione Immobile",
      location:
        "Stai pensando di vendere il tuo immobile? Scopri il suo reale valore di mercato con una valutazione professionale e accurata!",
      price: "",
      rooms: 5,
      size: 110,
      bath: 1,
      floor: 4,
      features: "Lusso, terrazzo",
    },
    // Aggiungi altri 3 immobili
    {
      image: img2,
      title: "Vendita Immobile",
      location:
        "Vuoi vendere il tuo immobile in modo rapido e sicuro? Affidati a noi per una vendita efficace al miglior prezzo!",
      price: "",
      rooms: 4,
      size: 95,
      bath: 2,
      floor: 3,
      features: "Balcone, ascensore",
    },
    {
      image: img3,
      title: "Affitto Immobile",
      location:
        "Metti a reddito il tuo immobile in tutta sicurezza! Troviamo per te inquilini affidabili e gestiamo ogni dettaglio dell’affitto.",
      price: "",
      rooms: 6,
      size: 200,
      bath: 3,
      floor: 2,
      features: "Piscina, giardino",
    },
  ];

  return (
    <Stack spacing={5} alignItems={"center"}>
      {" "}
      <Grid
        justifyContent="center" // Centra orizzontalmente
        alignItems="center" // Centra verticalmente (opzionale)
        container
        spacing={2}
      >
        {properties.map((property, index) => (
          <Grid
            justifyItems="center" // Centra orizzontalmente
            alignItems="center" // Centra verticalmente (opzionale)
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
          >
            <RealEstateService {...property} />
          </Grid>
        ))}
      </Grid>
      <Button
        component={Link} // Usa Link per fare navigazione
        to="/contattaci" // Imposta il percorso di destinazione
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          backgroundColor: "#0C6D8D",
          width: isMobile ? "60vw" : "20vw",
          maxWidth: "200px",
          margin: "80px auto 30px auto",
        }}
        startIcon={<ContactMail />}
      >
        Contattaci{" "}
      </Button>
    </Stack>
  );
};

export default RealEstateServizi;
